/**
 * Config: Algolia
 * -----------------------------------------------------------------------------
 * Global configuration for Algolia
 *
 */

import { getCategoryName } from '~/helpers/algolia'
import { formatRouteRefinement, formatRouteState } from '~/format/format-algolia'

/**
 * SEO-friendly router
 * @see https://github.com/algolia/doc-code-samples/blob/master/vue-instantsearch/routing-seo-friendly/src/App.vue
 */
export const router = {
  createURL({ routeState, location }) {
    const params = formatRouteState(routeState)
    const baseUrl = location.href.split('?')[0]

    if (!params.toString()) {
      return baseUrl
    }

    return `${baseUrl}?${params.toString()}`
  },

  parseURL({ qsModule, location }) {
    return formatRouteRefinement({ qsModule, location })
  },
}

export const searchRouter = {
  createURL({ routeState, location }) {
    const params = formatRouteState(routeState)
    const { origin, pathname } = location
    const query = params.get('query') || params.get('q') || ''

    params.delete('query')
    params.set('q', query)

    if (!query) {
      return `${origin}${pathname}`
    }

    let queryString = `q=${query}`

    if (cnvs.page.type === 'search') {
      queryString = params.toString()
    }

    return `${origin}${pathname}?${queryString}`
  },

  parseURL({ qsModule, location }) {
    const urlParams = qsModule.parse(location.search.slice(1))
    const { query, q } = urlParams || {}
    const formattedParams = formatRouteRefinement({ qsModule, location })

    if (cnvs.page.type === 'search') {
      formattedParams.query = getCategoryName(query || q || '')
      return formattedParams
    }

    return {
      query: getCategoryName(query || q || ''),
    }
  },
}
